import { useState } from 'react';

const useSelect = (props) => {
    const [data, setData] = useState(props.data ? props.data : []);

    const [value, setValue] = useState(props.value ? props.value : null);

    const [valid, setValid] = useState(true);

    const onChange = (event, _value) => {
        setValid(true);
        setValue(_value);
    };

    return {
        props: {
            data,
            value,
            valid,
            onChange,
        },
        setValid,
        setData,
        setValue,
    };
};

export default useSelect;
